import { makeStyles } from '@material-ui/core';

const styles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    marginBottom: 10,
  },
  cardContent: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    padding: '16px 8px',
  },
  cardOuterContent: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    padding: 0,
  },
  expand: {
    display: 'flex',
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },

  detailStyle: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    flexDirection: 'column',
    padding: 0,
  },
  diagnostic: {
    display: 'flex',
    alignItems: 'center',
  },
  updateStyle: {
    color: '#005abb',
    textDecorationLine: 'underline',
    textTransform: 'none',
    padding: 0,
    fontWeight: 'normal',
    marginRight: 5,
  },
  deleteStyle: {
    color: '#cd3a3a',
    textDecorationLine: 'underline',
    textTransform: 'none',
    padding: 0,
    fontWeight: 'normal',
    border: 'none',
  },
  textStyle: {
    whiteSpace: 'pre-line',
  },
  gridVertical: {
    display: 'flex',
    flexDirection: 'column',
  },
  cardHeader: {
    justifyContent: 'space-between',
    display: 'flex',
    fontWeight: 'bold',
  },
  cardHeaderIcon: {
    width: 'auto',
    height: '2rem',
    marginLeft: '0.5rem',
    verticalAlign: 'middle',
  },
  cardHeaderDescription: {
    fontWeight: 'normal',
    fontSize: '0.9em',
    justifyContent: 'space-between',
    display: 'flex',
  },
  cardHeaderStatus: {
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    margin: 0,
  },
  viewDetailButton: {
    textTransform: 'none',
    justifyContent: 'flex-start',
    padding: 0,
    fontWeight: 'normal',
  },
  checkbox: {
    marginTop: 15,
  },
  iconButton: {
    cursor: 'pointer',
    padding: 5,
    borderRadius: 50,
    color: 'white',
    marginRight: 5,
  },
}));

export default styles;
